module.exports = __webpack_public_path__ + "static/media/shopping-cart.896d83bc.svg";